<template>
    <ul class="search-result-header-tools">
        
        <search-list-upload></search-list-upload>

        <li title="Выбрать поля и скачать список" class="search-export-xls">
            <i @click="showExport" class="lnr lnr-download"></i>
        </li>

        <li title="Распечатать список" class="search-print">
            <i @click="print" class="lnr lnr-printer"></i>
        </li>
        
        <!-- <search-history/> -->
    </ul>
</template>

<script>
import searchListUpload from './searchListUpload.vue'
import searchHistory from './searchHistory.vue'

export default {
    components: {
        "search-list-upload": searchListUpload,
        "search-history": searchHistory
    },
    methods: {
        print(){
            window.print()
        },
        showExport(){
            this.$store.commit('search/showExportCsv', !this.$store.state.search.showExportCsv)
        }
        
    }
}
</script>

<style>
.search-result-header-tools {
    width: 160px;
    float: right;
    font-size: 0;
    white-space: nowrap;
    text-align: right;
}

.search-result-header-tools li i {
    cursor: pointer;
}

.search-result-header-tools li {
    display: inline-block;
    width: 40px;
    height: 40px;
    font-size: 20px;
    text-align: right;
    line-height: 40px;
}

.search-result-header-tools li i:hover {
    color: rgba(255,50,50,1.0);
}
</style>
